module.exports = __webpack_public_path__ + "img/background-abrapa.b52c9e79.jpg";